interface SunRaysProps {
  className?: string;
  variant?: "corner" | "full" | "side";
}

export default function SunRays({ className = "", variant = "corner" }: SunRaysProps) {
  if (variant === "full") {
    return (
      <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
        <svg viewBox="0 0 800 800" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] h-[150%] opacity-[0.06]">
          <defs>
            <linearGradient id="rayGradFull" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(45 100% 55%)" />
              <stop offset="100%" stopColor="hsl(174 72% 40%)" />
            </linearGradient>
          </defs>
          {Array.from({ length: 16 }).map((_, i) => (
            <polygon
              key={i}
              points="400,400 390,0 410,0"
              fill="url(#rayGradFull)"
              transform={`rotate(${i * 22.5} 400 400)`}
            />
          ))}
        </svg>
      </div>
    );
  }

  if (variant === "side") {
    return (
      <div className={`absolute overflow-hidden pointer-events-none ${className}`}>
        <svg viewBox="0 0 400 400" className="w-full h-full opacity-[0.08]">
          <defs>
            <linearGradient id="rayGradSide" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(45 100% 55%)" />
              <stop offset="100%" stopColor="hsl(174 72% 40%)" />
            </linearGradient>
          </defs>
          {Array.from({ length: 12 }).map((_, i) => (
            <polygon
              key={i}
              points="0,200 -10,-50 10,-50"
              fill="url(#rayGradSide)"
              transform={`rotate(${i * 30} 0 200)`}
            />
          ))}
        </svg>
      </div>
    );
  }

  return (
    <div className={`absolute overflow-hidden pointer-events-none ${className}`}>
      <svg viewBox="0 0 500 500" className="w-full h-full opacity-[0.07]">
        <defs>
          <linearGradient id="rayGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(45 100% 55%)" />
            <stop offset="100%" stopColor="hsl(185 70% 48%)" />
          </linearGradient>
        </defs>
        {Array.from({ length: 14 }).map((_, i) => (
          <polygon
            key={i}
            points="0,0 -15,-200 15,-200"
            fill="url(#rayGrad)"
            transform={`rotate(${i * 25.7} 0 0)`}
          />
        ))}
      </svg>
    </div>
  );
}
